import module from 'fanconsultores/module.js'
import template from './template.html'

class AppLoginComponent {
  constructor ($session, $state, $scope) {
    this.$session = $session
    this.$state = $state
    this.quequedState = null
    this.error = null
    this.is_auth = false
    this.loading = false
    this.autenticar = false
    this.pass_expired = undefined
    this.credential = {
      username: '',
      password: '',
    }

    $scope.$on('$sessionAuth', () => (this.sesionAuth()))
  }

  login () {
    if (this.loading) return

    this.loading = true

    return this.$session.auth(this.credential)
      .catch((error) => {
        if (error === 'PASS_EXPIRED') {
          this.$state.go('app.sesion.pass_expired', {credential: this.credential}, {location: false})
        } else {
          this.error = error
        }
      })
      .finally(() => (this.loading = false))
  }

  sesionAuth () {
    this.is_auth = this.$session.isAuth()
    this.$state.go(this.quequedState.state, this.quequedState.params)
  }
}

module.component('appLogin', {
  controller: AppLoginComponent,
  template,
  bindings: {
    quequedState: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/app/login/component.js